import React, { createContext, useContext } from 'react';
import { WlConfig } from 'config/wls/wlConfig';
import { getWlConfig } from 'config/wls/wlConfig';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export interface WlContextValue  {
  config: WlConfig | null;
  wlId: number | null;
}
export const WlContext = createContext<WlContextValue | null>(null);

export function WlProvider({ children }: { children: React.ReactNode }) {
  const wlId = useSelector((state: RootState) => state.settings.wlId);

  const config = wlId ? getWlConfig(wlId) : null;

  return (
    <WlContext.Provider value={{ config, wlId }}>{children}</WlContext.Provider>
  );
}

export function useWl(): {
  config: WlConfig | null;
  wlId: number | null;
} {
  const context = useContext(WlContext);
  if (!context) {
    throw new Error('useWlConfig must be used inside WlProvider');
  }

  return context;
}
